<template>
    <div class="container">
        <menu-list></menu-list>
        <div class="main boxshadow order-page">
            <div class="basics-section ">
                <div class="basics-section-main">
                    <div class="head">
                        <span class="head-1">财务明细</span>
                        <span class="head-2">Payment Details</span>
                    </div>
                    <div class="cont" style="padding: 0 10px">
                        <el-table
                                header-row-class-name="custom-header-style"
                                cell-class-name="custom-style"
                                :data="financial.items"
                                style="width: 100%">
                            <el-table-column
                                    align="center"
                                    width="200px"
                                    label="入账时间">
                                <template slot-scope="scope">
                                    {{new Date(scope.row.createTime).$Format('yyyy-MM-dd hh:mm:ss')}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="amount"
                                    align="center"
                                    width="200px"
                                    label="收入/支出">
                                <template slot-scope="scope">
                                    {{scope.row.type>0?'收入':'支出'}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="amount"
                                    align="right"
                                    width="200px"
                                    label="费用USD">
                                <template slot-scope="scope">
                                    {{(scope.row.type * scope.row.amount).toFixed(2)}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    width="100px">
                            </el-table-column>
                            <el-table-column
                                    prop="note"
                                    align="left"
                                    label="备注">
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
        <div class="pagination-wrap">
            <div class="pagination">
                <el-pagination
                        prev-text="上一页"
                        next-text="下一页"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="financial.pagination.pageNo"
                        :page-size="financial.pagination.pageSize"
                        layout="prev, pager, next, jumper, slot, total"
                        :total="financial.pagination.total">
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </el-pagination>
            </div>
        </div>
        <div class="foot">
            闽ICP备17025076号-2 <span style="margin: 0 20px"></span>©2017-{{new Date().getFullYear()}} All rights reserved.
        </div>
    </div>
</template>

<script>

    export default {
        name: "order",
        data() {
            return {
                financial:{
                    pagination:{
                        pageNo:1,
                        pageSize:20
                    }
                }
            }
        },
        created() {
            this.getList();
        },
        methods: {
            getList() {
                let params = {
                    pagination: {
                        pageNo: this.financial.pagination.pageNo,
                        pageSize: this.financial.pagination.pageSize,
                    }
                }
                this.axios.post("/student/finance/seller/list",params).then(res=>{
                    if(res.succeed){
                        this.financial = res
                    }
                })
            },
            handleSizeChange() {

            },
            handleCurrentChange(val) {
                this.financial.pagination.pageNo = val;
                this.getList()
            }
        }
    }
</script>

<style scoped lang="scss">

    .main.order-page {
        .fee-wrap {
            display: flex;
            flex-direction: column;
            font-size: 12px;
            > div {
                display: flex;
                > div.fee-item {
                    display: flex;
                    width: 50%;
                     span.name {
                        width: 60px;
                         text-align: right;
                         margin-right: 2px;
                    }
                    span {
                        word-break: keep-all;
                    }
                }
            }
        }
        .address-wrap {
            display: flex;
            flex-wrap: wrap;
            font-size: 12px;
            justify-content: center;
            > span {
                margin-right: 6px;
            }
        }
    }

    .pagination-wrap {
        margin-top: 30px;
        display: inline-block;

        > div.pagination {
            padding: 0 20px;
            height: 60px;
            background: #FFFFFF;
            border-radius: 10px;
            box-shadow: 3px 10px 20px -6px #b5cdd3;
            display: flex;
            align-items: center;
            margin-bottom: 20px;
        }
    }

    div.foot {
        width: 100%;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
        font-size: 14px;
        color: #ABD5DB;
    }

    .set-logistics-dialog {
        .main {
            display: flex;
            justify-content: center;
            padding-bottom: 50px;

            > div.main-item {
                display: flex;
                flex-direction: column;
                font-size: 16px;
                font-weight: bolder;
                align-items: center;
                margin-right: 32px;

                > div {
                    &:first-child {
                        margin-bottom: 10px;
                    }

                    &:last-child {
                        padding: 15px 58px;
                        background: #089bab;
                        color: #FFFFFF;
                        border-radius: 10px;

                        input {
                            /*width: 130px;*/
                            border: 1px dashed #ff9800;
                            height: 48px;
                            line-height: 48px;
                            border-radius: 10px;
                            outline: none;
                            padding: 0 10px;
                            box-sizing: border-box;
                            font-weight: bolder;
                            text-align: center;
                        }
                    }
                }
            }

            div.cancle-wrap {
                display: flex;
                align-items: center;

                div.cancle-wrap-item {
                    border: 1px dashed #adadad;
                    padding: 36px;
                    border-radius: 10px;
                    /*transition: all 0.3s linear;*/
                    cursor: pointer;

                    &:first-child {
                        margin-right: 30px;
                    }

                    &:hover, &.active {
                        background: rgba(255, 152, 0, 0.21);
                        /*transition: all 0.3s linear;*/
                    }

                    .item-box {
                        border-radius: 20px;
                        background: #FDAD53;
                        color: #FFFFFF;
                        padding: 10px 20px;

                        i {
                            padding: 0 30px;
                        }
                    }
                }
            }
        }

        .footer {
            display: flex;
            justify-content: center;
            align-items: center;
            padding-bottom: 30px;
        }
    }
</style>
